<div class="stopwatch-container" *ngIf="this.currentTask.variables.startStopwatch">
  <div class="stopwatch-display">
    <i class="fas fa-clock"></i>
    <span class="time">{{ stopwatchService.time$ | async | date : 'mm:ss' }}</span>
  </div>
</div>